/**
 * Route gate for the MSI3 org progress view:
 * - loading → Loading page
 * - unsigned → auth with next=
 * - global admin OR msi3 faculty grant OR org-admin → children
 * - otherwise → home
 *
 * This is a UX guard only; getMsi3OrgProgress re-checks authorization on the
 * server and only ever returns the caller's own organization.
 */
import { Navigate, useLocation } from "react-router-dom";
import Loading from "components/Loading";
import { useAuth } from "hooks/useAuth";
import { useMsi3FacultyGrant } from "../msi3FacultyGrant";

export default function RequireMsi3OrgProgress({ children }) {
  const { user, userData, userLoading, isGlobalAdmin } = useAuth();
  const { loading: grantLoading, isFaculty } = useMsi3FacultyGrant();
  const location = useLocation();

  if (userLoading || grantLoading) return <Loading page />;

  if (!user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth?next=${encodeURIComponent(next)}`} replace />;
  }

  const isOrgAdmin =
    userData?.role === "admin" || userData?.activeOrgRole?.role === "admin";

  if (isGlobalAdmin || isFaculty || isOrgAdmin) {
    return children;
  }

  return <Navigate to="/" replace />;
}
